import { SalesSites } from './sales-sites.component.js';

export * from './sales-sites.component.js';
export default SalesSites;

if (!customElements.get('der-tm-roundtrip-booking-request-sales-sites')) {
    customElements.define('der-tm-roundtrip-booking-request-sales-sites', SalesSites);
}
